import { jsx } from "react/jsx-runtime";
import { useState, useMemo } from "react";
import { ZIndex } from "../common/UI/ZIndex.js";
import styled from "styled-components";
const Layer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: ${ZIndex.level1200};
`;
const useModal = ({ modal, onOpen, onClose }) => {
  const [isOpen, setIsOpen] = useState(false);
  const open = async (args) => {
    if (onOpen)
      onOpen(args);
    setIsOpen(true);
  };
  const close = () => {
    if (onClose)
      onClose();
    setIsOpen(false);
  };
  const render = () => {
    if (!isOpen || !modal) {
      return null;
    }
    return /* @__PURE__ */ jsx(Layer, { children: modal(close) });
  };
  return useMemo(
    () => ({ open, close, render, isOpen }),
    [isOpen, modal, onOpen, onClose]
  );
};
export {
  Layer,
  useModal
};
